<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-container
    fill-height
    fluid
    grid-list-xl>
    <v-layout justify-center wrap>
      <v-flex md12>
        <material-card
          color="green"
          title="جدول المتابعة"
          :text="patientname">
          <v-data-table
                    :search="search"
                    :loading="isloading"
                    :loading-text="loadingtext"
                    :headers="headers"
                    :items="items"
                    ref="tbl">
            <template v-slot:top>
              <v-toolbar flat color="white">
                <v-dialog v-model="newDialog" max-width="600px">
                  <template v-slot:activator="{ on }">
                    <v-container>
                      <v-row>
                        <v-col cols="12" md="4" xs="12" sm="12">
                            <v-btn large color="green" dark class="mb-2" v-on="on">إضافة مدخل جديد</v-btn>
                        </v-col>
                        <v-col cols="12" md="8" xs="12" sm="12">
                          <v-text-field
                            filled
                            v-model="search"
                            append-icon="mdi-magnify"
                            label="بحث ..."
                            single-line
                            hide-details></v-text-field>
                        </v-col>
                      </v-row>
                    </v-container>
                  </template>
                  <v-form
                          v-model="valid"
                          lazy-validation
                          ref="form"
                          id="new-form">
                  <v-card>
                    <v-card-title>
                      <span class="headline">{{ dialogTitle }}</span>
                    </v-card-title>

                    <v-card-text>
                      <v-container>
                        <v-row>
                          <v-col cols="12" sm="6" md="6">

                            <v-menu offset-y>
                              <template v-slot:activator="{ on }">
                                <v-text-field aria-autocomplete="none"
                                              v-on="on"
                                              :rules="Rules('dateRules')"
                                              required
                                              v-model="follow.nextvisit"
                                              class="purple-input"
                                              label="موعد المراجعة"></v-text-field>
                              </template>
                              <v-date-picker dark v-model="follow.nextvisit" />
                            </v-menu>
                          </v-col>
                          <v-col cols="12" sm="6" md="6">
                            <v-switch v-model="follow.recurringstatus" label="زيارات متكررة ؟" />
                          </v-col>

                        </v-row>
                          <v-row>
                            <v-col cols="12" sm="6" md="6">
                              <v-autocomplete
                                      readonly

                                      v-model="currentPatient"
                                      :items="mypatients"
                                      item-text="text"
                                      label="إسم المراجع"
                                      return-object
                              >
                              </v-autocomplete>
                            </v-col>

                            <v-col cols="12" sm="6" md="6">
                              <v-text-field
                                      v-model="follow.recurring"
                                      required
                                      :rules="Rules('numberRules')"
                                      label="المدة مابين المراجعات (بالأيام)"></v-text-field>
                            </v-col>

                            <v-col cols="12" sm="6" md="6">
                              <v-text-field
                                      v-model="follow.drug"
                                      required
                                      :rules="Rules('nameRules')"
                                      label="العلاج"></v-text-field>
                            </v-col>

                              <v-col cols="12" sm="6" md="6">
                                  <v-text-field
                                          v-model="follow.disease"
                                          required
                                          :rules="Rules('nameRules')"
                                          label="المرض"></v-text-field>
                              </v-col>
                              <v-col cols="12" sm="6" md="6">
                                  <v-text-field
                                          v-model="follow.diagnose"
                                          required
                                          :rules="Rules('nameRules')"
                                          label="التشخيص"></v-text-field>
                              </v-col>
                            <v-col cols="12" sm="6" md="6">
                              <v-text-field
                                      v-model="follow.notes"
                                      required
                                      :rules="Rules('nameRules')"
                                      label="الملاحظات"></v-text-field>
                            </v-col>
                          </v-row>
                      </v-container>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="blue darken-1" text @click="newDialog = false">إلغاء</v-btn>
                      <v-btn color="blue darken-1" form="new-form" @click="validateFunc" :disabled="!valid">حفظ</v-btn>
                    </v-card-actions>
                  </v-card>
                  </v-form>
                </v-dialog>


              </v-toolbar>
            </template>


            <template v-slot:item.recurringstatus="{ item }">
              <v-icon :color="getColor(item.recurringstatus)">{{ getLabel(item.recurringstatus) }}</v-icon>
            </template>



            <template v-slot:item.action="{ item }">
              <v-btn
                      primary
                      dark
                      center
                      @click="editRefers(item)">
              <v-icon
                      medium
              >
                mdi-pencil
              </v-icon>

              </v-btn>
              <v-btn
                      warning
                      dark
                      @click="deleteItem(item)">
              <v-icon
                      medium
              >
                mdi-delete
              </v-icon>
              </v-btn>
            </template>

          </v-data-table>
        </material-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>

import {__HTTP,FormHeader,__HAS_PERM} from "@/utils/utils";

export default {
  computed: {
    currentPatient(){
      return this.$route.params.id;
    },
    patientname() {
      return this.$route.params.pname
    },
    mypatients() {
      return this.patients
    }
  },
  watch: {
    dialog (val) {
      val || this.close()
    },
    newDialog (val) {
      val || this.close()
    },
  },
  methods: {
    getColor(data) {
      if (data === "1") return "green";
      else return "grey";
    },
    getLabel(data) {
      if (data === "1") return "mdi-check";
      else return "mdi-close-circle-outline";
    },

    Rules(type) {
      return this.$store.state.appRules[type];
    },

    getPatients() {
      __HTTP("?do=getmypatients",{},FormHeader,(res) => {
         res.map((i) => {
          this.patients.push(
              {
                text: i.fullname,
                value: i.id
              });
        })
        this.getFollowUp();
      })
    },

    getFollowUp: function() {
      __HTTP("?do=getfollowup&id="+this.$route.params.id,{},FormHeader,(res) => {
        this.isloading = false
        this.items = res;
      })

    },
    editRefers (item) {
      //console.log(item);
      let ind = this.patients.findIndex(obj => obj.value == item.patientid);
       this.follow =
          {
              patient: {
                value: item.patientid,
                text: this.patients[ind].text
              },
              patientid: item.patientid,
              drug: item.drug,
              nextvisit: item.nextvisit,
              disease: item.disease,
              diagnose: item.diagnose,
              notes: item.notes,
              recurring: item.recurring,
              recurringstatus: item.recurringstatus == 0 ? null : 1,
              isedit: true,
              id: item.id,
              item: item
        }
      this.dialogTitle = "تعديل معلومات المتابعة"
      this.newDialog = true
    },

    deleteItem (item) {
      const index = this.items.indexOf(item)
      let c = confirm('Are you sure you want to delete this item?');
      if (c) {
        __HAS_PERM(11,this.$store.state.loggedUser.id,() => {
          __HTTP("?do=delete",{type: "followup",id: item.id},FormHeader,() => {
            this.items.splice(index, 1)
          })
        });
      }
    },
    validateFunc() {
      if (this.$refs.form.validate()) {
        this.save()
      }
    },

    save () {
      __HTTP("?do=newfollowup",{
        patient: this.currentPatient,
        disease: this.follow.disease,
        diagnose: this.follow.diagnose,
        drug: this.follow.drug,
        notes: this.follow.notes,
        nextvisit: this.follow.nextvisit,
        recurring: this.follow.recurring,
        recurringstatus: this.follow.recurringstatus,
        isedit: this.follow.isedit ? true : false,
        id: this.follow.id
      },FormHeader, (res) => {
        if (this.follow.isedit == false)
          this.items.push({
            //patient: this.currentPatient.text,
            pid: this.currentPatient,
            disease: this.follow.disease,
            diagnose: this.follow.diagnose,
            drug: this.follow.drug,
            notes: this.follow.notes,
            nextvisit: this.follow.nextvisit,
            recurring: this.follow.recurring,
            recurringstatus: this.follow.recurringstatus ? '1' : '0',
            addby: '-',
            adddate: res.adddate,
            id: res.id
          })
        else {
          var ind = this.items.findIndex(obj => parseInt(obj.id) == res.id);
          this.items.splice(ind, 1, {
            //patient: this.follow.patient,
            patientid: this.currentPatient,
            disease: this.follow.disease,
            diagnose: this.follow.diagnose,
            drug: this.follow.drug,
            notes: this.follow.notes,
            nextvisit: this.follow.nextvisit,
            recurring: this.follow.recurring,
            recurringstatus: this.follow.recurringstatus ? '1' : '0',
            addby: '-',
            adddate: res.adddate,
            id: res.id
          })
        }
        this.follow.isedit = false
        this.dialogTitle = 'إضافة قيد متابعة جديد'
        this.newDialog = false
      })

    },
  },
  created() {
     this.getPatients();
    },
  data: () => ({
    valid: true,
    dialogTitle: 'إضافة قيد متابعة جديد',
    search: '',
    patients: [],
    newDialog: false,
    isloading: true,
    loadingtext: "يرجى الانتظار جاري تحميل البيانات",
    dialog: false,
    toBeEdit: null,
      follow:
          {
              patient: null,
              patientid: null,
              notes: '',
              drug: '',
              disease: '',
              diagnose: '',
              nextvisit: '',
              recurring: '',
              recurringstatus: '',
              isedit: false
        },
    headers: [
      {
            sortable: true,
            text: '#',
            value: 'id',
            align: 'right'
      },
      {
            sortable: true,
            text: 'الزيارة القادمة',
            value: 'nextvisit',
            align: 'right'
      },
      {
            sortable: true,
            text: 'المرض',
            value: 'disease',
            align: 'right'
      },
      {
            sortable: true,
            text: 'التشخيص',
            value: 'diagnose',
            align: 'right'
      },
        {
            sortable: true,
            text: 'العلاج',
            value: 'drug',
            align: 'right'
        },

        {
            sortable: true,
            text: 'زيارة متكررة',
            value: 'recurringstatus',
            align: 'right'
        },

        {
            sortable: true,
            text: 'المدة بين الزيارات',
            value: 'recurring',
            align: 'right'
        },
        {
            sortable: true,
            text: 'ملاحظات',
            value: 'notes',
            align: 'right'
        },
      {
            sortable: true,
            text: 'اضيفت بواسطة',
            value: 'addby',
            align: 'right'
      },
      {
            sortable: true,
            text: 'اضيفت بتاريخ',
            value: 'adddate',
            align: 'right'
      },
      { text: 'الادوات', value: 'action', sortable: false },
    ],
    items: [

    ]
  })
}
</script>
